import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Typography, Card, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { api } from '../../../services/apiClient';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/pt-br'; // Importa o locale português
import styles from './style.module.scss';

const { Title, Text } = Typography;

const FluxoDiario = () => {
  const [subOperacoesPorDia, setSubOperacoesPorDia] = useState({});

  useEffect(() => {
    moment.locale('pt-br'); // Configura o locale para português
    fetchSubOperacoes();
  }, []);

  const fetchSubOperacoes = async () => {
    try {
      const response = await api.get('/entradas-saidas');
      console.log('\n\nresponse', response.data);
      const { subOperacoesPorDia } = response.data;
      setSubOperacoesPorDia(subOperacoesPorDia || {});
    } catch (error) {
      console.error('Erro ao carregar dados das suboperações.', error);
    }
  };

  const formatNumber = (number) => {
    return isNaN(number) ? 'R$ 0,00' : number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const renderGroupedData = (groupedData) => {
    return Object.keys(groupedData).map((date) => {
      const { pagos, naoPagos, saidas } = groupedData[date];

      const totalPagos = pagos.reduce((acc, curr) => acc + curr.valorParcela, 0);
      const totalNaoPagos = saidas.reduce((acc, curr) => acc + curr.valor, 0);

      return (
        <div key={date} className={styles.dayContainer}>
          <div className={styles.dateHeader}>
            <h1 className={styles.headerDate} >{moment(date).format('dddd, DD [de] MMM YYYY')}</h1>
            <Text  className={styles.saldoDia}>
              Saldo do dia: <span style={{color: totalPagos - totalNaoPagos > 0 ? 'green': ' red'}} >{formatNumber(totalPagos - totalNaoPagos)}</span>
            </Text>
          </div>

          <Divider />

          {/* Listagem dos Pagos */}
          <div className={styles.subOperacaoContainer}>
            {pagos.length > 0 && (
              pagos.map((item, index) => (
                <div key={index} className={styles.contractItem}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <div className={styles.contractDetail}>{item.nomeCliente}</div>
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <div className={styles.contractDetail}>{item.cpfCliente}</div>
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <div className={styles.contractDetail}>{formatNumber(item.valorParcela)}</div>
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <div className={styles.contractStatus}>
                        <Text type='success'>Pagamento Pix</Text> {/* Ou outra forma de pagamento */}
                      </div>
                    </Col>
                  </Row>
                </div>
              ))
            ) }
          </div>

          {/* <Divider /> */}
          {/* Listagem dos Não Pagos */}
          <div className={styles.subOperacaoContainer}>
            {saidas.length > 0 && (
              saidas.map((item, index) => (
                <div key={index} className={styles.contractItem}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <div className={styles.contractDetail}>{item.nomeCliente}</div>
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <div className={styles.contractDetail}>{item.cpfCliente}</div>
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <div className={styles.contractDetail}>{formatNumber(item.valor)}</div>
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={6}>
                      <div className={styles.contractStatus}>
                        <Text type='danger'>Pagamento</Text> 
                      </div>
                    </Col>
                  </Row>
                </div>
              ))
            ) }
          </div>
          <Divider />

        </div>
      );
    });
  };

  return (
    <div className={styles.container}>
      <Breadcrumb
        items={[
          {
            title: (
              <Link to='/'>
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='24' viewBox='0 0 23 24' fill='none'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.2 3.32275C10.3525 3.32275 9.52129 3.55496 8.79652 3.99415L4.15884 6.80459C3.47686 7.21786 2.91295 7.8 2.52159 8.49478C2.13022 9.18957 1.92462 9.97352 1.92464 10.7709V16.607C1.92464 17.837 2.41325 19.0166 3.28298 19.8863C4.15272 20.7561 5.33233 21.2447 6.56232 21.2447H15.8377C17.0677 21.2447 18.2473 20.7561 19.117 19.8863C19.9867 19.0166 20.4754 17.837 20.4754 16.607V10.77C20.4752 9.97279 20.2695 9.18885 19.8781 8.49428C19.4868 7.79972 18.923 7.21776 18.2412 6.8046L13.6035 3.99416C12.8787 3.55497 12.0475 3.32275 11.2 3.32275ZM9.75792 5.58066C10.1928 5.31715 10.6915 5.17783 11.2 5.17783C11.7085 5.17783 12.2072 5.31715 12.6421 5.58066L17.2798 8.39109C17.6888 8.63899 18.0271 8.98817 18.2619 9.40492C18.4967 9.82159 18.6201 10.2918 18.6203 10.77V16.607C18.6203 17.345 18.3271 18.0528 17.8053 18.5746C17.2834 19.0964 16.5757 19.3896 15.8377 19.3896H14.9101V16.607C14.9101 15.623 14.5193 14.6793 13.8235 13.9835C13.1277 13.2878 12.184 12.8969 11.2 12.8969C10.216 12.8969 9.27232 13.2878 8.57653 13.9835C7.88074 14.6793 7.48985 15.623 7.48985 16.607V19.3896H6.56232C5.82432 19.3896 5.11656 19.0964 4.59472 18.5746C4.07288 18.0528 3.77971 17.345 3.77971 16.607V10.7709C3.7797 10.2925 3.90306 9.82209 4.13788 9.40522C4.3727 8.98835 4.71104 8.63906 5.12023 8.3911L9.75792 5.58066ZM12.5117 15.2953C12.8596 15.6432 13.0551 16.115 13.0551 16.607V19.3896H9.34493V16.607C9.34493 16.115 9.54037 15.6432 9.88826 15.2953C10.2362 14.9474 10.708 14.7519 11.2 14.7519C11.692 14.7519 12.1638 14.9474 12.5117 15.2953Z'
                    fill='#757575'
                  />
                </svg>
              </Link>
            ),
          },
          {
            title: <span>Financeiro</span>,
          },
          {
            title: 'Fluxo de Caixa',
          },
        ]}
      />
      {/* <Row justify='center' gutter={[16, 16]}>
        <Col span={8}>
          <Link to='/financeiro/fluxodecaixa'>
            <Button type='primary' icon={<PlusOutlined />}>
              Adicionar
            </Button>
          </Link>
        </Col>
        <Col span={8}>
          <Card className={styles.card}>
            <div className={styles.icon}>
              <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
                <path d='M8.00016 4.16675V5.83341H13.4918L3.8335 15.4917L5.0085 16.6667L14.6668 7.00841V12.5001H16.3335V4.16675H8.00016Z' fill='#3c6e29' />
              </svg>
            </div>
            <Title level={4} className={styles.title}>
              {formatNumber(Object.values(subOperacoesPorDia).reduce((acc, day) => acc + day.pagos.reduce((total, item) => total + item.valorParcela, 0), 0))}
            </Title>
            <Text className={styles.text}>Total de Pagos</Text>
          </Card>
        </Col>
        <Col span={8}>
          <Card className={styles.card}>
            <div className={styles.icon}>
              <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
                <path d='M16.8335 4.50825L15.6585 3.33325L6.00016 12.9916V7.49992H4.3335V15.8333H12.6668V14.1666H7.17516L16.8335 4.50825Z' fill='#3c6e29' />
              </svg>
            </div>
            <Title level={4} className={styles.title}>
              {formatNumber(Object.values(subOperacoesPorDia).reduce((acc, day) => acc + day.naoPagos.reduce((total, item) => total + item.valorParcela, 0), 0))}
            </Title>
            <Text className={styles.text}>Total de Não Pagos</Text>
          </Card>
        </Col>
      </Row> */}

      <div className={styles.filtro}>
        <h2>Saldo em conta</h2>
        <h1>{formatNumber(Object.values(subOperacoesPorDia).reduce((acc, day) => acc + day.pagos.reduce((total, item) => total + item.valorParcela, 0) - day.naoPagos.reduce((total, item) => total + item.valorParcela, 0), 0))}</h1>
      </div>
      <div className={styles.fluxoList}>{renderGroupedData(subOperacoesPorDia)}</div>
    </div>
  );
};

export default FluxoDiario;
